import request from '@/utils/request'

export function prepareGoogleOAuth() {
  return request({
    url: '/api/oauth/google/prepare',
    method: 'post'
  })
}

export function getGoogleIntegrationStatus() {
  return request({
    url: '/api/integration/google/status',
    method: 'get'
  })
}

export function disconnectGoogleCalendar() {
  return request({
    url: '/api/integration/google/disconnect',
    method: 'delete'
  })
}

export function listGoogleCalendarEvents(params) {
  return request({
    url: '/api/integration/google/events',
    method: 'get',
    params
  })
}
